import { render, staticRenderFns } from "./Touch.vue?vue&type=template&id=3c35800b&scoped=true&"
import script from "./Touch.vue?vue&type=script&lang=js&"
export * from "./Touch.vue?vue&type=script&lang=js&"
import style0 from "./Touch.vue?vue&type=style&index=0&id=3c35800b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c35800b",
  null
  
)

export default component.exports